import {
  ADD_NOTIFICATIONS_SINGLE,
  ADD_NOTIFICATIONS_SINGLE_SUCCESS,
  ADD_NOTIFICATIONS_SINGLE_FAILURE,
  ADD_NOTIFICATIONS_MULTIPLE,
  ADD_NOTIFICATIONS_MULTIPLE_SUCCESS,
  ADD_NOTIFICATIONS_MULTIPLE_FAILURE,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_SUCCESS,
  CHANGE_NOTIFICATIONS_STATUS,
  CHANGE_NOTIFICATIONS_STATUS_FAILURE,
  CHANGE_NOTIFICATIONS_STATUS_SUCCESS,
} from "../constants";

export default class NotificationsAction {
  static getNotifications(payload, cb) {
    return {
      type: GET_NOTIFICATIONS,
      payload,
      cb,
    };
  }
  static getNotificationsSuccess(payload) {
    return {
      type: GET_NOTIFICATIONS_SUCCESS,
      payload,
    };
  }
  static getNotificationsFailure(payload) {
    return {
      type: GET_NOTIFICATIONS_FAILURE,
      payload,
    };
  }
  static addNotificationsSingle(payload, cb) {
    return {
      type: ADD_NOTIFICATIONS_SINGLE,
      payload,
      cb,
    };
  }
  static addNotificationsSingleSuccess(payload) {
    return {
      type: ADD_NOTIFICATIONS_SINGLE_SUCCESS,
      payload,
    };
  }
  static addNotificationsSingleFailure(payload) {
    return {
      type: ADD_NOTIFICATIONS_SINGLE_FAILURE,
      payload,
    };
  }
  static addNotificationsMultiple(payload, cb) {
    return {
      type: ADD_NOTIFICATIONS_MULTIPLE,
      payload,
      cb,
    };
  }
  static addNotificationsMultipleSuccess(payload) {
    return {
      type: ADD_NOTIFICATIONS_MULTIPLE_SUCCESS,
      payload,
    };
  }
  static addNotificationsMultipleFailure(payload) {
    return {
      type: ADD_NOTIFICATIONS_MULTIPLE_FAILURE,
      payload,
    };
  }
  static changeNotificationsStatus(payload, cb) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS,
      payload,
      cb,
    };
  }
  static changeNotificationsStatusSuccess(payload) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS_SUCCESS,
      payload,
    };
  }
  static changeNotificationsStatusFailure(payload) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS_FAILURE,
      payload,
    };
  }
}
